export const columnData = [
  {
    name: 'Student Id',
    value: 'studentId',
  },
  {
    name: 'First Name',
    value: 'firstname',
  },
  {
    name: 'Last name',
    value: 'lastname',
  },
  {
    name: 'Phone number',
    value: 'phone',
  },
  {
    name: 'Email',
    value: 'email',
  },

  {
    name: 'Rank',
    value: 'rank',
  },
  {
    name: 'Stage',
    value: 'stage',
  },
  {
    name: 'Status',
    value: 'status',
  },
]
